import React, {ReactNode} from 'react';

import RemoveFieldButton from './RemoveFieldButton/RemoveFieldButton';

import styles from './BatchEdit.module.scss';

interface IEditableFieldRowProps {
    label?: string;
    onRemove: () => void;
    children: ReactNode;
}

const EditableFieldRow: React.FC<IEditableFieldRowProps> = ({label, onRemove, children}) => {
    const removeButton = <RemoveFieldButton onRemove={onRemove} floating={!label}/>;

    return (
        <div className={styles.row}>
            {label ? (
                <div className={styles.rowHeader}>
                    <span className={styles.rowTitle}>{label}</span>
                    {removeButton}
                </div>
            ) : removeButton}
            {children}
        </div>
    );
};

export default EditableFieldRow;
